/* Excellent. This is actually one component I'd make slightly smarter than the others, because it owns the navigation between the editor pages.

Rather than hardcoding buttons, we'll generate them from an array. That makes it very easy to add or remove tabs later. */
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";

const WaiverTabs = ({ waiver, onNavigate }) => { {  /* ////////NEW 3rd July 2026  onNavigate added for autosave on tab clicks */ }

    // TODO: Replace with your actual property once available
    const showLocations =
        !(waiver?.isNewVersion ||
        waiver?.waiverStatus === "new_version");
    /* const showLocations = waiver?.showLocationTab; That way the frontend doesn't need to know why the tab is shown—it simply renders based on the backend's decision. */

    const location = useLocation(); {  /* ////////NEW 3rd July 2026 */ }
    const activeTab = location.pathname.split("/").pop(); {  /* ////////NEW 3rd July 2026 */ }

    const tabs = [
        {
            label: "Edit Waiver Content",
            path: "content",
        },
        {
            label: "Edit Eligibility Rules",
            path: "eligibility",
        },
        {
            label: "Edit Minors",
            path: "minors",
        },
        {
            label: "Edit Returning",
            path: "returning",
        },
    ];

    if (showLocations) {
        tabs.push({
            label: "Edit Locations",
            path: "locations",
        });
    }

    return (

        <div className="border-b border-gray-200 mb-6">

            <div className="flex gap-10">

                 {/* {tabs.map(tab => (

                   <NavLink
                        key={tab.path}
                        to={tab.path}
                        end
                        className={({ isActive }) =>
                            `pb-3 text-sm font-medium transition-colors border-b-2 ${
                                isActive
                                    ? "border-yellow-400 text-black"
                                    : "border-transparent text-gray-500 hover:text-black"
                            }`
                        }
                    >
                        {tab.label}
                    </NavLink> 

                    

                ))}*/} {  /* ////////NEW 3rd July 2026 */ }

                {  /* ////////NEW 3rd July 2026 */ }
                {tabs.map(tab => (
                    <button
                        key={tab.path}
                        onClick={() => onNavigate(tab.path)}
                        className={`pb-3 text-sm font-medium transition-colors border-b-2 ${
                            activeTab === tab.path
                                ? "border-yellow-400 text-black"
                                : "border-transparent text-gray-500 hover:text-black"
                        }`}
                    >
                        {tab.label}
                    </button>
                ))}

            </div>

        </div>

    );

};

export default WaiverTabs;